import Vue from 'vue'
import VueI18n from 'vue-i18n'

// import en from './langs/en.json'
// import zhTW from './langs/zh_TW.json'

const checkKey = (key) => {
  if (key === 'zh_cn') return 'zh_CN'
  else if (key === 'zh_tw') return 'zh_TW'
  return key
}

const importAll = (r) => r.keys().reduce((acc, key) => {
  acc[checkKey(key.replace(/\.(\/|json)/g, ''))] = r(key)
  return acc
}, [])

const keys = importAll(require.context('../../subI18n/src/frontend/', true, /\.json$/))

// import en from '../../subI18n/src/frontend/en.json'
// import zhTw from '../../subI18n/src/frontend/zh_tw.json'
// import ja from '../../subI18n/src/frontend/ja.json'
// import th from '../../subI18n/src/frontend/th.json'
// import ko from '../../subI18n/src/frontend/ko.json'

Vue.use(VueI18n)

const messages = {
  ...keys
}

// const messages = {
//   en,
//   'zh_TW': zhTw,
//   ja,
//   th
// }

const i18n = new VueI18n({
  messages,
  // fallbackLocale: 'en',
  fallbackLocale: [
    'en',
    'zh_TW'
  ],
  silentFallbackWarn: true
})

export default i18n
